import React, { useState, useEffect } from "react"

import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-plugin-sanity-image"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

import * as styles from "./subscribe-all.module.scss"
import Grid from "../../atoms/grid"
import Heading from "../../atoms/heading"
import Illustration from "../../atoms/illustration"
import Wrapper from "../../atoms/wrapper"
import FormState from "../../molecules/form-state"
import SubscribeFirst from "../../molecules/subscribe-first"
import SubscribeSecond from "../../molecules/subscribe-second"
import SubscribePressList from "../../molecules/subsribe-press-list"
import SubscribeThird from "../../molecules/subsribe-third"

const Subscribe = () => {
  const { allSanityDictionary, allSanitySubscribe } = useStaticQuery(graphql`
    {
      allSanityDictionary {
        nodes {
          key {
            current
          }
          value
        }
      }
      allSanitySubscribe(sort: { vertical: { name: DESC } }) {
        nodes {
          title
          vertical {
            cm_id
            color
            name
            slug {
              current
            }
          }
          heading {
            default
            referral
            additional
            growth_channel {
              sqf_channel
              heading
              growth_channel_details
            }
          }
          phone {
            default {
              ...ImageWithPreview
            }
            growth_channel {
              image {
                ...ImageWithPreview
              }
              growth_channel_details
              sqf_channel
            }
            referral {
              ...ImageWithPreview
            }
          }
          illustration {
            default {
              image {
                ...ImageWithPreview
              }
            }
          }
          description {
            _rawDefault
            _rawReferral
            growth_channel {
              sqf_channel
              growth_channel_details
              _rawDescription
            }
          }
          press {
            name
            url
            dark_logo {
              ...ImageWithPreview
            }
            logo {
              ...ImageWithPreview
            }
          }
          ctas {
            cta
            cta_additional
            ctas {
              text
              url
            }
          }
          success {
            title
            _rawDefault
            _rawReferral
            growth_channel {
              sqf_channel
              growth_channel_details
              _rawDescription
            }
          }
          additional_fields {
            name
            tag
            type
            values
          }
        }
      }
    }
  `)
  const [steps, setSteps] = useState(
    allSanitySubscribe.nodes.map((subscribe) => ({
      name: subscribe.vertical.slug.current,
      step: "first",
    }))
  )
  const [leftArrow, setLeftArrow] = useState(true)
  const [rightArrow, setRightArrow] = useState(true)
  const [email, setEmail] = useState("")

  useEffect(() => {
    setSteps(
      steps.map((step) => ({
        name: step.name,
        step: sessionStorage.getItem(`subscribed_${step.name.replace("-", "")}`)
          ? "third"
          : "first",
      }))
    )
  }, [])

  const setStepVertical = (newStep, vertical) => {
    setSteps(
      steps.map((step) =>
        step.name === vertical ? { name: step.name, step: newStep } : step
      )
    )
  }

  const arrows = (e) => {
    const { scrollLeft } = document.getElementsByClassName(styles.grid)[0]

    if (e.deltaY === 0) {
      if (e.deltaX > 0 && scrollLeft >= 400) {
        setLeftArrow(true)
        setRightArrow(false)
      } else if (e.deltaX < 0 && scrollLeft <= 400) {
        setLeftArrow(false)
        setRightArrow(true)
      } else {
        setLeftArrow(true)
        setRightArrow(true)
      }
    }
  }

  return (
    <div id="subscribe" className={styles.subscribe}>
      <Wrapper container className={styles.spacer}>
        <Heading className={styles.heading}>
          {
            allSanitySubscribe.nodes.find(
              (node) => node.vertical.slug.current === "daily-sports"
            ).heading.default
          }
          <Illustration
            icon={
              allSanitySubscribe.nodes.find(
                (node) => node.vertical.slug.current === "daily-sports"
              ).illustration.default?.image
            }
          />
        </Heading>
        <SubscribePressList
          press={
            allSanitySubscribe.nodes.find(
              (node) => node.vertical.slug.current === "daily-sports"
            ).press
          }
          label={
            allSanityDictionary.nodes.find(
              (item) => item.key.current === "press_label"
            )?.value
          }
          center
        />
        <div
          className={`${styles.container} ${
            leftArrow ? styles.container__leftArrow : ""
          } ${rightArrow ? styles.container__rightArrow : ""}`}
        >
          <GoogleReCaptchaProvider
            reCaptchaKey={process.env.GATSBY_RECAPTCHA_KEY}
          >
            <Grid col={steps.length} className={styles.grid} nowrap>
              {steps.map((vertical) => (
                <div
                  className={`${styles.spacer} ${styles.vertical}`}
                  onWheel={arrows}
                >
                  <FormState condition={vertical.step === "first"}>
                    <SubscribeFirst
                      data={allSanitySubscribe.nodes.find(
                        (node) => node.vertical.slug.current === vertical.name
                      )}
                      changeStep={setStepVertical}
                      changeEmail={setEmail}
                      all
                      light={false}
                    />
                  </FormState>
                  <FormState condition={vertical.step === "second"} all>
                    <SubscribeSecond
                      data={allSanitySubscribe.nodes.find(
                        (node) => node.vertical.slug.current === vertical.name
                      )}
                      changeStep={setStepVertical}
                      email={email}
                      all
                      light={false}
                    />
                  </FormState>
                  <FormState flex condition={vertical.step === "third"}>
                    <SubscribeThird
                      data={allSanitySubscribe.nodes.find(
                        (node) => node.vertical.slug.current === vertical.name
                      )}
                      all
                      pageType={vertical}
                      bg="sky"
                    />
                  </FormState>
                  <div>
                    <Image
                      {...allSanitySubscribe.nodes.find(
                        (node) => node.vertical.slug.current === vertical.name
                      ).phone.default}
                      width={400}
                      className={styles.phone}
                      alt=""
                    />
                  </div>
                </div>
              ))}
            </Grid>
          </GoogleReCaptchaProvider>
        </div>
      </Wrapper>
    </div>
  )
}

export default Subscribe
